const CloseButton = {
    view: ({attrs: {onclick}}) =>
        <button class="btn close-button btn-circle" type="submit" onclick={(e) => onclick(e)}>
            <i class="icon-close"></i>
        </button>
};

export default CloseButton;
